import React from 'react';
import {ReactHint} from '../components/components';
import {ColorSelection} from './dialogs';
import {MDCAnchorMenu,MDCPopOver,MDCMenu,MDCDialog,MDCFormSwitch,MDCIconTextInput} from '../components/mdc-components';

export class ToolbarFormatMenu extends React.Component{
    constructor(props){
       super(props);
    }

    render(){
        return(
           <ToolbarMenu label="Format" onMenuSelected={this.props.onMenuSelected.bind(this)} id="format">
             <li className="mdc-list-item" role="menuitem" tabIndex="0" data-command="formatblock" data-value="h2">Title 2</li>
             <li className="mdc-list-item" role="menuitem" tabIndex="0" data-command="formatblock" data-value="h3">Title 3</li>
             <li className="mdc-list-item" role="menuitem" tabIndex="0" data-command="formatblock" data-value="h4">Title 4</li>
             <li className="mdc-list-item" role="menuitem" tabIndex="0" data-command="formatblock" data-value="h5">Title 5</li>
             <li className="mdc-list-item" role="menuitem" tabIndex="0" data-command="formatblock" data-value="h6">Title 6</li>
             <li className="mdc-list-item" role="menuitem" tabIndex="0" data-command="formatblock" data-value="p">Paragraph</li>
             <li className="mdc-list-item" role="menuitem" tabIndex="0" data-command="formatblock" data-value="pre">Preformatted</li>
             {/* Optional per-page formats supplied by the host component, e.g.
                 customFormats={[{label:'Event Time', value:'showroom-event-time'}]}.
                 Default command 'formatclass' wraps the selection in a span with
                 that class; pass command/value explicitly for anything else.
                 Renders nothing when the prop is absent. */}
             {(this.props.customFormats || []).map(function(f, i){
                return (
                  <li className="mdc-list-item" role="menuitem" tabIndex="0"
                      key={'custom-format-' + i}
                      data-command={f.command || 'formatclass'}
                      data-value={f.value}>{f.label}</li>
                );
             })}
           </ToolbarMenu>
        );
    }
}

export class ToolbarEditMenu extends React.Component{
    constructor(props){
       super(props);
    }

    render(){
        return(
          <ToolbarMenu label="Edit" onMenuSelected={this.props.onMenuSelected} id="edit">
             <li className="mdc-list-item" role="menuitem" tabIndex="0" data-command="copy">Copy</li>
             <li className="mdc-list-item" role="menuitem" tabIndex="0" data-command="cut">Cut</li>
             <li className="mdc-list-item" role="menuitem" tabIndex="0" data-command="clean">Clean Selection</li>
           </ToolbarMenu>
        );
    }
}

export class ToolbarMediaMenu extends React.Component{
    constructor(props){
       super(props);
    }

    render(){
        return(
            <ToolbarMenu label="Media" onMenuSelected={this.props.onMediaSelected} id="media">
              <li className="mdc-list-item" role="menuitem" tabIndex="0" data-command="image">Add Image</li>
              <li className="mdc-list-item" role="menuitem" tabIndex="0" data-command="video">Add Youtube Video</li>
              <li className="mdc-list-item" role="menuitem" tabIndex="0" data-command="tweet">Add Tweet</li>
            </ToolbarMenu>
        );
    }
}

export class ToolbarColorPicker extends React.Component{
    constructor(props){
       super(props);
       var defaultColors=['#F44336','#E91E63','#9C27B0','#673AB7','#3F51B5','#2196F3','#009688','#4CAF50','#8BC34A','#CDDC39','#FFEB3B','#FF9800','#FF5722','#795548','#9E9E9E',"#d38cac","#8b8b8b","#CAA56C"];
       if(this.props.colors) this.colors=this.props.colors.split(',');
       else this.colors=defaultColors;
       if(this.props.addColors){
           var addColors=this.props.addColors.split(',');
           this.colors=this.colors.concat(addColors);
       }
    }

    onColorClick(event){
       if(this.props.onColorSelect){
           var target=event.target;
           var color=target.dataset.color;
           this.props.onColorSelect(color);
       }
    }

    onMouseDown(event){
        event.preventDefault();
    }

    render(){
        var icon=this.props.icon;
        if(!icon) icon='format_color_text';
        var id=this.props.id;
        if(!id) id='color-picker';
        var hint=this.props.hint;
        if(!hint) hint='Color';
        var colorNodes = this.colors.map((color)=> {
            return (
                <ColorSelection color={color} key={color}  />
            );
        });
        return(
            <MDCAnchorMenu menuId={id}>
               <div className="toolbar-button" data-anchor tabIndex="0">
                  <ReactHint events position="bottom" />
                   <i className="material-icons" data-rh={hint}>{icon}</i>
                </div>
                <MDCPopOver id={id} disableInit="true">
                  <div className="color-picker-container">
                       <div className="flex-colors" onClick={this.onColorClick.bind(this)} onMouseDown={this.onMouseDown.bind(this)}>
                          {colorNodes}
                       </div>
                  </div>
                </MDCPopOver>
            </MDCAnchorMenu>
        );
    }
}

export class ToolbarMenu extends React.Component{
    constructor(props){
       super(props);
    }

    onMenuSelected(event){
      if(this.props.onMenuSelected) this.props.onMenuSelected(event);
    }

    render(){
        return(
            <div className="toolbar-menu">
               <MDCAnchorMenu  onMenuSelected={this.onMenuSelected.bind(this)} menuId={this.props.id}>
                   <div className="toolbar-menu-anchor" data-anchor tabIndex="0">
                      <span>{this.props.label}</span>
                      <i className="material-icons">keyboard_arrow_down</i>
                   </div>
                   <MDCMenu disableInit="true" id={this.props.id}>
                     {this.props.children}
                   </MDCMenu>
               </MDCAnchorMenu>
            </div>
        )
    }
}

export class ToolbarLink extends React.Component{
    constructor(props){
       super(props);
    }

    onClick(event){
        if(this.props.onSaveSelection) this.props.onSaveSelection();
        this.dialog.show();
    }

    onMouseDown(event){
        event.preventDefault();
    }

    onDialogAccept(){
        var url=this.input.value;
        this.input.value='';
        if(this.props.onDialogAccept) {
            this.props.onDialogAccept(url);
        }
    }

    render(){
        return(
            <div className="toolbar-button">
               <MDCDialog ref={(ref) => this.dialog = ref} onDialogAccept={this.onDialogAccept.bind(this)}>
                   <MDCIconTextInput icon="link" label="Link" id="link" ref={(ref) => this.input = ref} />
               </MDCDialog>
               <ReactHint events position="bottom" />
               <i className="material-icons"  data-rh="Add Link" onClick={this.onClick.bind(this)} onMouseDown={this.onMouseDown.bind(this)}>insert_link</i>
            </div>
        )
    }
}

export class ToolbarSeparator extends React.Component{
    render(){
        return(
            <div className="separator"></div>
        )
    }
}

export class ToolbarButton extends React.Component{
    constructor(props){
       super(props);
    }

    onClick(event){
       if(this.props.onButtonClick)this.props.onButtonClick({command:this.props.command,value:this.props.value});
    }

    onMouseDown(event){
        event.preventDefault();
    }

    render(){
        return(
            <div className="toolbar-button" onClick={this.onClick.bind(this)} onMouseDown={this.onMouseDown.bind(this)}>
               <ReactHint events position="bottom" />
               <i className="material-icons"  data-rh={this.props.hint}>{this.props.icon}</i>
            </div>
        )
    }
}

export class ToolbarHideButton extends React.Component{
    constructor(props){
       super(props);
    }

    onClick(event){
       if(this.props.onToolbarHide)this.props.onToolbarHide();
    }

    onMouseDown(event){
        event.preventDefault();
    }

    render(){
        return(
            <div className="toolbar-button" onClick={this.onClick.bind(this)} onMouseDown={this.onMouseDown.bind(this)}>
               <ReactHint events position="bottom" />
               <i className="material-icons"  data-rh="Hide">close</i>
            </div>
        )
    }
}

export class ToolbarButtonGroup extends React.Component{
    constructor(props){
       super(props);
    }

    render(){

       return(
           <div className="toolbar-button-group">
             {this.props.children}
           </div>
       );
    }
}

export class EditorToolbar extends React.Component{
    constructor(props){
       super(props);
    }

    setFocus(){
       this.element.classList.add('active');
       if(this.props.onToolbarActive) this.props.onToolbarActive();
    }

    removeFocus(){
       
    }

    hide(){
        this.element.classList.remove('active');
    }

    render(){
       var cls='rich-editor-toolbar';
       if(this.props.cls) cls+= ' ' + this.props.cls;
       return(
           <div className="rich-editor-toolbar-container">
              <div className={cls} tabIndex="0" ref={(ref) => this.element = ref}>
              {this.props.children}
              </div>
           </div>
       );
    }
}

export class ToolbarDefaultButtonGroup extends React.Component{
    constructor(props){
       super(props);
    }

    onButtonClick(event){
       this.props.onButtonClick(event);
    }
    
    render(){
        return(
           <ToolbarButtonGroup>
               <ToolbarButton icon="undo" hint="Undo" command="undo" onButtonClick={this.onButtonClick.bind(this)} />
               <ToolbarButton icon="redo" hint="Redo" command="redo" onButtonClick={this.onButtonClick.bind(this)} />
               <ToolbarButton icon="format_clear" hint="Clear Formatting" command="removeFormat" onButtonClick={this.onButtonClick.bind(this)}  />
               <ToolbarHideButton onToolbarHide={this.props.onToolbarHide} />
               <ToolbarSeparator />
               <ToolbarButton icon="format_bold" hint="Bold" command="bold" onButtonClick={this.onButtonClick.bind(this)} />
               <ToolbarButton icon="format_underlined" hint="Underline" command="underline" onButtonClick={this.onButtonClick.bind(this)} />
               <ToolbarButton icon="format_italic" hint="Italic" command="italic" onButtonClick={this.onButtonClick.bind(this)} />
               <ToolbarSeparator />
               <ToolbarButton icon="format_align_left" hint="Left Align" command="justifyLeft" onButtonClick={this.onButtonClick.bind(this)} />
               <ToolbarButton icon="format_align_right" hint="Right Align" command="justifyRight" onButtonClick={this.onButtonClick.bind(this)} />
               <ToolbarButton icon="format_align_center" hint="Center Align" command="justifyCenter" onButtonClick={this.onButtonClick.bind(this)} />
               <ToolbarButton icon="format_quote" hint="Quote" command="formatBlock" value="blockquote" onButtonClick={this.onButtonClick.bind(this)} />
               <ToolbarButton icon="format_list_numbered" hint="Numbered List" command="insertorderedlist" onButtonClick={this.onButtonClick.bind(this)} />
               <ToolbarButton icon="format_list_bulleted" hint="Bullet List" command="insertunorderedlist" onButtonClick={this.onButtonClick.bind(this)} />
           </ToolbarButtonGroup>
        )
    }
}

export class ToolbarTinyButtonGroup extends React.Component{
    constructor(props){
       super(props);
    }

    onButtonClick(event){
       this.props.onButtonClick(event);
    }

    onWordFormatClick(event){
       this.props.onWordFormatClick(event);
    }

    onColorSelect(color){
       this.props.onColorSelect(color);
    }

    onCreateLink(url){
       this.props.onCreateLink(url);
    }

    onSaveSelection(){
       this.props.onSaveSelection();
    }
    
    render(){
        return(
           <ToolbarButtonGroup>
               <ToolbarButton icon="undo" hint="Undo" command="undo" onButtonClick={this.onButtonClick.bind(this)} />
               <ToolbarButton icon="redo" hint="Redo" command="redo" onButtonClick={this.onButtonClick.bind(this)} />
               <ToolbarButton icon="format_clear" hint="Clear Formatting" command="removeFormat" onButtonClick={this.onButtonClick.bind(this)}  />
               <ToolbarButton icon="functions" hint="Clean Word" onButtonClick={this.onWordFormatClick.bind(this)}  />
               <ToolbarHideButton onToolbarHide={this.props.onToolbarHide} />
               <ToolbarSeparator />
               <ToolbarButton icon="format_bold" hint="Bold" command="bold" onButtonClick={this.onButtonClick.bind(this)} />
               <ToolbarButton icon="format_underlined" hint="Underline" command="underline" onButtonClick={this.onButtonClick.bind(this)} />
               <ToolbarButton icon="format_italic" hint="Italic" command="italic" onButtonClick={this.onButtonClick.bind(this)} />
               <ToolbarSeparator />
               <ToolbarColorPicker onColorSelect={this.onColorSelect.bind(this)} addColors={this.props.addColors} />
               <ToolbarLink onDialogAccept={this.onCreateLink.bind(this)} onSaveSelection={this.onSaveSelection.bind(this)} /> 
               <ToolbarSeparator />
               <ToolbarButton icon="format_quote" hint="Quote" command="formatBlock" value="blockquote" onButtonClick={this.onButtonClick.bind(this)} />
               <ToolbarButton icon="format_list_numbered" hint="Numbered List" command="insertorderedlist" onButtonClick={this.onButtonClick.bind(this)} />
               <ToolbarButton icon="format_list_bulleted" hint="Bullet List" command="insertunorderedlist" onButtonClick={this.onButtonClick.bind(this)} />
           </ToolbarButtonGroup>
        )
    }
}

export class ToolbarMinimalButtonGroup extends React.Component{
    constructor(props){
       super(props);
    }

    onButtonClick(event){
        console.log('button click');
       this.props.onButtonClick(event);
    }

    onColorSelect(color){
       this.props.onColorSelect(color);
    }

    onCreateLink(url){
       this.props.onCreateLink(url);
    }

    onSaveSelection(){
       this.props.onSaveSelection();
    }

    onHtmlCheckedChange(checked){
       this.props.onHtmlCheckedChange(checked);
    }
    
    render(){
        return(
           <ToolbarButtonGroup>
               <ToolbarButton icon="undo" hint="Undo" command="undo" onButtonClick={this.onButtonClick.bind(this)} />
               <ToolbarButton icon="redo" hint="Redo" command="redo" onButtonClick={this.onButtonClick.bind(this)} />
               <ToolbarButton icon="format_clear" hint="Clear Formatting" command="removeFormat" onButtonClick={this.onButtonClick.bind(this)}  />
               <ToolbarHideButton onToolbarHide={this.props.onToolbarHide} />
               <ToolbarButton icon="format_bold" hint="Bold" command="bold" onButtonClick={this.onButtonClick.bind(this)} />
               <ToolbarSeparator />
               <ToolbarColorPicker onColorSelect={this.onColorSelect.bind(this)} addColors={this.props.addColors} />
               <ToolbarLink onDialogAccept={this.onCreateLink.bind(this)} onSaveSelection={this.onSaveSelection.bind(this)} /> 
               <ToolbarSeparator />
               <MDCFormSwitch label="html" onCheckedChange={this.onHtmlCheckedChange.bind(this)} />
           </ToolbarButtonGroup>
        )
    }
}

export default{
    ToolbarFormatMenu,
    ToolbarEditMenu,
    ToolbarMediaMenu,
    ToolbarColorPicker,
    ToolbarMenu,
    ToolbarLink,
    ToolbarSeparator,
    ToolbarButton,
    ToolbarHideButton,
    ToolbarButtonGroup,
    EditorToolbar,
    ToolbarDefaultButtonGroup,
    ToolbarTinyButtonGroup,
    ToolbarMinimalButtonGroup
}